import FormattedMessage from 'I18n/components/FormattedMessage';
import { TODAY, YESTERDAY, THIS_WEEK, LAST_WEEK, THIS_MONTH, LAST_MONTH, THIS_YEAR, LAST_YEAR } from 'UIComponents/dates/dateRangePresets';
import { jsx as _jsx } from "react/jsx-runtime";
export const UPDATE_FILTER_DEBOUNCE_MS = 500;

//Assignee
export const ASSIGNEE_PLACEHOLDER = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.assignee.placeholder"
});
export const DATE_FILTER_KEY = 'DATES';
//Date
export const PRESET_DATES = [TODAY, YESTERDAY, THIS_WEEK, LAST_WEEK, THIS_MONTH, LAST_MONTH, THIS_YEAR, LAST_YEAR];